@if (visible) {
<div class="fixed inset-0 z-[120] flex items-center justify-center p-6">
  <div class="absolute inset-0 bg-[rgba(0,0,0,0.16)]" (click)="close()"></div>
  <div
    class="relative z-10 border-[1px] bg-light border border-[#9aa8bc1b] rounded-3xl shadow-modal p-4 sm:p-6 w-[560px] max-w-full"
    (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <!-- header con botón cerrar -->
    <div class="flex items-start justify-between w-full mb-4 gap-4">
      <div class="space-y-4 flex-1 min-w-0">
        <h2 class="font-poppins font-semibold text-base sm:text-[22px] leading-[24px] text-text-primary">
          {{ title }}
        </h2>
        @if (message) {
        <p class="font-poppins font-medium text-[14px] text-text-primary leading-5 break-words line-clamp-2">
          {{ message }}
        </p>
        }
      </div>
      <button class="text-[10px] text-text-primary flex-shrink-0" (click)="close()" aria-label="Cerrar">
        <i class="fi fi-br-cross text-text-primary text-[10px]"></i>
      </button>
    </div>

    <!-- Contenido -->
    <div class="mb-4 sm:mb-6">
      @if (inputLabel) {
      <label class="block font-poppins font-medium text-xs leading-[18px] text-secundary mb-1">
        {{ inputLabel }}
      </label>
      }
      <input type="text" [(ngModel)]="localValue" (ngModelChange)="onInputChange($event)"
        (compositionstart)="onCompositionStart()" (compositionend)="onCompositionEnd($event)"
        [placeholder]="inputPlaceholder"
        class="w-full px-4 py-3 rounded-2xl font-poppins text-base text-text-primary placeholder:text-text-placeholder focus:outline-none"
        [ngClass]="mensajeErrorNombre ? 'border-2 border-negative' : 'border border-soft-gray'"
        (keyup.enter)="confirm()" maxlength="51" />

      <div *ngIf="mensajeErrorNombre" class="flex items-center gap-1 mt-[5px] pl-4">
        <i class="fi fi-sr-triangle-warning text-negative flex items-center"></i>
        <span class="text-[#B1000F] text-xs font-poppins leading-[18px]">{{ mensajeErrorNombre }}</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-4">
      <app-buttons type="dark-borderless" [text]="cancelText" size="medium" typeButton="button" (buttonClick)="close()">
      </app-buttons>
      <app-buttons type="primary" [text]="continueText" size="medium" typeButton="button" [disabled]="!canContinue"
        (buttonClick)="confirm()">
      </app-buttons>
    </div>
  </div>
</div>
}
